module.exports = __webpack_public_path__ + "b8c36b4b4f07dc285dbda73e61e4c644.svg";